var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.87451 15.6253C1.87451 15.7911 1.94036 15.9501 2.05757 16.0673C2.17478 16.1845 2.33375 16.2503 2.49951 16.2503C2.66527 16.2503 2.82424 16.1845 2.94145 16.0673C3.05866 15.9501 3.12451 15.7911 3.12451 15.6253C3.12658 13.8026 3.85157 12.0551 5.14043 10.7663C6.4293 9.47741 8.17678 8.75241 9.99951 8.75035H15.9909L13.3073 11.4332C13.19 11.5504 13.1242 11.7095 13.1242 11.8753C13.1242 12.0412 13.19 12.2003 13.3073 12.3175C13.4246 12.4348 13.5837 12.5007 13.7495 12.5007C13.9154 12.5007 14.0744 12.4348 14.1917 12.3175L17.9417 8.56753C17.9998 8.50949 18.0459 8.44056 18.0774 8.36468C18.1088 8.28881 18.125 8.20748 18.125 8.12535C18.125 8.04321 18.1088 7.96188 18.0774 7.88601C18.0459 7.81014 17.9998 7.7412 17.9417 7.68316L14.1917 3.93316C14.0744 3.81588 13.9154 3.75 13.7495 3.75C13.5837 3.75 13.4246 3.81588 13.3073 3.93316C13.19 4.05044 13.1242 4.20949 13.1242 4.37535C13.1242 4.5412 13.19 4.70026 13.3073 4.81753L15.9909 7.50035H9.99951C7.84532 7.50262 5.78002 8.35938 4.25678 9.88262C2.73354 11.4059 1.87678 13.4712 1.87451 15.6253Z",
    fill: "#616E85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForward);
export default __webpack_public_path__ + "static/media/Forward.83a8c17c331212c82d63e0da73330017.svg";
export { ForwardRef as ReactComponent };